var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartIconinline = function SvgHeartIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinejoin: "round",
    d: "m8.086 12.31-.87-.777c-3.09-2.749-5.13-4.561-5.13-6.786 0-1.813 1.452-3.237 3.3-3.237 1.044 0 2.046.476 2.7 1.23a3.62 3.62 0 0 1 2.7-1.23c1.848 0 3.3 1.424 3.3 3.237 0 2.225-2.04 4.037-5.13 6.792z"
  })));
};
export default SvgHeartIconinline;